import Dropdown from './Dropdown'
import DropdownItem from './DropdownItem'
import DropdownHeader from './DropdownHeader'
import DropdownSelect from './DropdownSelect'

Dropdown.Header = DropdownHeader
Dropdown.Item = DropdownItem
Dropdown.Select = DropdownSelect

export default Dropdown